export default {
  methods: {
    truncate(str, length) {
      if (!str || str == null || str == undefined) return;
      return str.length > length ? str.substr(0, length - 1) + " ..." : str;
    },
  },
};
